import React, { useState, useEffect, useRef } from "react";

import { useSelector } from "react-redux";

import { CommonAxios } from "../components/CommonAxios";
import ListWrap from "../components/list/ListWrap";

const ListPage = () => {
  return (
    <>
      <ListWrap />
    </>
  );
};

export default ListPage;
